import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface StickyActionBarProps {
  children: ReactNode;
  /** Optional left-side info (e.g. "Step 2 of 5", autosave indicator) */
  info?: ReactNode;
  className?: string;
}

/**
 * Sticky bottom action bar for long forms / wizards.
 * Stays in view on mobile so primary actions are always reachable.
 */
export const StickyActionBar = ({ children, info, className }: StickyActionBarProps) => {
  return (
    <div
      className={cn(
        "sticky bottom-0 left-0 right-0 z-30 -mx-4 sm:mx-0 mt-6",
        "border-t border-border bg-card/95 backdrop-blur-md",
        "px-4 sm:px-5 py-3 shadow-[0_-4px_16px_-4px_hsl(var(--background)/0.6)]",
        "rounded-t-lg sm:rounded-lg",
        className
      )}
    >
      <div className="flex items-center justify-between gap-3 flex-wrap">
        {info && <div className="text-xs text-muted-foreground flex items-center gap-2">{info}</div>}
        <div className={cn("flex items-center gap-2 flex-wrap", !info && "ml-auto")}>{children}</div>
      </div>
    </div>
  );
};

export default StickyActionBar;
